/** Utilidades compartidas de reportes */

export function toIsoDate(d) {
  const pad = (n) => String(n).padStart(2, '0');
  return `${d.getFullYear()}-${pad(d.getMonth() + 1)}-${pad(d.getDate())}`;
}

export function defaultMonthRange() {
  const now = new Date();
  const start = new Date(now.getFullYear(), now.getMonth(), 1);
  const end = new Date(now.getFullYear(), now.getMonth() + 1, 0);
  return { startDate: toIsoDate(start), endDate: toIsoDate(end) };
}

export function rangeLastDays(days) {
  const end = new Date();
  const start = new Date();
  start.setDate(start.getDate() - (days - 1));
  return { startDate: toIsoDate(start), endDate: toIsoDate(end) };
}

export function rangeLastMonths(months) {
  const end = new Date();
  const start = new Date();
  start.setMonth(start.getMonth() - months);
  return { startDate: toIsoDate(start), endDate: toIsoDate(end) };
}

export function rangePreviousMonth() {
  const now = new Date();
  const start = new Date(now.getFullYear(), now.getMonth() - 1, 1);
  const end = new Date(now.getFullYear(), now.getMonth(), 0);
  return { startDate: toIsoDate(start), endDate: toIsoDate(end) };
}

export function validatePeriod(startDate, endDate) {
  if (!startDate || !endDate) {
    return 'Indicá fecha desde y hasta.';
  }
  if (startDate > endDate) {
    return 'La fecha desde no puede ser posterior a la fecha hasta.';
  }
  return null;
}

export function formatDateUy(value) {
  if (!value) return '—';
  const raw = String(value).slice(0, 10);
  const [y, m, d] = raw.split('-');
  if (!y || !m || !d) return String(value);
  return `${d}/${m}/${y}`;
}

export function formatMinutes(minutes) {
  const m = Number(minutes) || 0;
  const h = Math.floor(m / 60);
  const rest = m % 60;
  if (h <= 0) return `${rest} min`;
  return `${h}h ${String(rest).padStart(2, '0')} min`;
}
